import _ from "lodash";

import IColumn from "models/IColumn";
import { modifyCurrencyField } from "helpers/formatting";

export const columnsExcel: IColumn[] = [
  {
    title: "INVOICES_NUMBER",
    key: "Number"
  },
  {
    title: "INVOICES_DATE",
    key: "InvoiceDate",
    type: "date"
  },
  {
    title: "DELIVERIES_END_DATE",
    key: "DeliveryDate",
    type: "date"
  },
  {
    title: "PAYMENT_DATE",
    key: "PaymentDate",
    type: "date"
  },
  {
    title: "ORDERS_PAYMENT",
    key: "AdvancePayment",
    type: "boolean"
  },
  {
    title: "INVOICES_TYPE",
    key: "InvoiceType.Description"
  },
  {
    title: "ORDERS_NUMBER",
    key: "Lines[index].GoodsOrderNumber",
    isArray: true,
    render: (row, col, index) => {
      const productCode = _.get(
        row,
        `Lines[${index}].Item.ProductType.ProductGroup.ProductCategory.Code`,
        ""
      );
      return productCode.toLowerCase() !== "dien"
        ? _.get(row, "Order.Number")
        : _.get(row, _.replace(col.key, "index", index));
    }
  },
  {
    title: "EXTERNAL_DOCUMENT",
    key: "ExternalReferenceNumber"
  },
  {
    title: "PURCHASE_TYPE",
    key: "PurchaseType"
  },
  {
    title: "COUNTERPARTY_NR_REL",
    key: "CounterParty.Number"
  },
  {
    title: "COUNTERPARTY_COMPANY",
    key: "CounterParty.Name"
  },
  {
    title: "COUNTERPARTY_VAT",
    key: "VATPostingGroupCounterParty.Description"
  },
  {
    title: "PREFERRED_GROWER_NR_REL",
    key: "Supplier.Number"
  },
  {
    title: "PREFERRED_GROWER_COMPANY",
    key: "Supplier.Name"
  },
  {
    title: "BUYER_NR_REL",
    key: "OriginalCustomer.Number"
  },
  {
    title: "BUYER_COMPANY",
    key: "OriginalCustomer.Name"
  },
  {
    title: "PRODUCT_GROUP",
    key: "Lines[index].Item.ProductType.ProductGroup.ProductCategory.Code",
    isArray: true,
    render: (row, col, index) => {
      const productCode = _.get(row, _.replace(col.key, "index", index));
      return productCode && productCode.toLowerCase() !== "dien"
        ? productCode
        : "-";
    }
  },
  {
    title: "LINE_NUMBER",
    key: "Lines[index].Number",
    isArray: true
  },
  {
    title: "DESCRIPTION",
    key: "Lines[index].Description/Lines[index].GrowerClaims",
    isArray: true,
    render: (row, col, index) => {
      const keys = col.key.split("/");
      return (
        _.get(row, _.replace(keys[0], "index", index)) +
        _.get(row, _.replace(keys[1], "index", index))
      );
    }
  },
  {
    title: "QUANTITY",
    key: "Lines[index].Quantity",
    isArray: true,
    type: "number",
    render: (row, col, index) => modifyCurrencyField(row, col.key, index)
  },
  {
    title: "QUANTITY_UNIT",
    key: "Lines[index].QuantityUnit.Description",
    isArray: true
  },
  {
    title: "INVOICES_GROSS",
    key: "Lines[index].LineAmountExVat",
    isArray: true,
    type: "currency",
    render: (row, col, index) => modifyCurrencyField(row, col.key, index)
  },
  {
    title: "INVOICES_BTW_GROSS",
    key: "Lines[index].VatAmount",
    isArray: true,
    type: "currency",
    render: (row, col, index) => modifyCurrencyField(row, col.key, index)
  },
  {
    title: "VAT_RATE",
    key: "Lines[index].VatPercentage",
    isArray: true,
    type: "percent"
  },
  {
    title: "INVOICES_INCL_BTW",
    key: "Lines[index].LineAmountIncVat",
    isArray: true,
    type: "currency",
    render: (row, col, index) => modifyCurrencyField(row, col.key, index)
  },
  {
    title: "INVOICES_INCL_BTW_RANGE",
    key: "Lines[index].LineAmountIncVat159",
    isArray: true,
    type: "currency",
    customData: {
      range: "15-09",
      percentOne: "100",
      percentTwo: "85"
    },
    render: (row, col, index) => modifyCurrencyField(row, col.key, index)
  },
  {
    title: "INVOICES_INCL_BTW_RANGE",
    key: "Lines[index].LineAmountIncVat111",
    isArray: true,
    type: "currency",
    customData: {
      range: "01-11",
      percentOne: "100",
      percentTwo: "15"
    },
    render: (row, col, index) => modifyCurrencyField(row, col.key, index)
  },
  {
    title: "INVOICES_COMMISSION_AMOUNT",
    key: "Lines[index].ProvisionAmountExVat",
    type: "currency",
    isArray: true
  },
  {
    title: "INVOICES_COMMISSION_SALE",
    key: "Lines[index].ProvisionAmountExVat159",
    type: "currency",
    isArray: true,
    customData: {
      range: "15-09",
      percentOne: "100",
      percentTwo: "85"
    }
  },
  {
    title: "INVOICES_COMMISSION_SALE",
    key: "Lines[index].ProvisionAmountExvat111",
    type: "currency",
    isArray: true,
    customData: {
      range: "01-11",
      percentOne: "100",
      percentTwo: "15"
    }
  },
  {
    title: "INVOICES_COMMISSION_PERCENT",
    key: "Lines[index].ProvisionPercentage",
    isArray: true,
    type: "percent"
  },
  {
    title: "INVOICES_BTW_AMOUNT",
    key: "Lines[index].ProvisionVatAmount",
    type: "currency",
    isArray: true
  },
  {
    title: "INVOICES_BTW_RATE",
    key: "Lines[index].ProvisionVatPercentage",
    isArray: true,
    type: "percent"
  },
  {
    title: "INVOICES_TOTAL",
    key: "InvoiceAmountExVat",
    type: "currency",
    render: (row, col) =>
      !row.index || row.index === 0 ? modifyCurrencyField(row, col.key) : 0
  },
  {
    title: "INVOICES_TOTAL_INCL_VAT",
    key: "InvoiceAmountIncVat",
    type: "currency",
    render: (row, col) =>
      !row.index || row.index === 0 ? modifyCurrencyField(row, col.key) : 0
  },
  {
    title: "INVOICES_TOTAL_INCL_VAT_RANGE",
    key: "InvoiceAmountIncVat159",
    type: "currency",
    customData: {
      range: "15-09",
      percentOne: "100",
      percentTwo: "85"
    },
    render: (row, col) =>
      !row.index || row.index === 0 ? modifyCurrencyField(row, col.key) : 0
  },
  {
    title: "INVOICES_TOTAL_INCL_VAT_RANGE",
    key: "InvoiceAmountIncVat111",
    type: "currency",
    customData: {
      range: "01-11",
      percentOne: "100",
      percentTwo: "15"
    },
    render: (row, col) =>
      !row.index || row.index === 0 ? modifyCurrencyField(row, col.key) : 0
  },
  {
    title: "INVOICES_PAID",
    key: "PaidAmount",
    type: "currency",
    render: (row, col) =>
      !row.index || row.index === 0 ? modifyCurrencyField(row, col.key) : 0
  },
  {
    title: "INVOICES_REST",
    key: "RemainingAmount",
    type: "currency",
    render: (row, col) =>
      !row.index || row.index === 0 ? modifyCurrencyField(row, col.key) : 0
  },
  {
    title: "INVOICES_COMMENT",
    key: "Lines[index].ExternalRemarks",
    isArray: true
  }
];
